import Component from '../core/Component'
import enquire from 'enquire.js'
import { queries } from '../core/config'

const STATES = {
    ACTIVE: 'is-active'
}

export default class TagListItem extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            image: null,
            name: null,
            link: null
        }

        this.move = {
            active: false,
            startX: 0,
            startY: 0,
            x: 0,
            y: 0
        }

        this.box = null
        this.nameBox = null

        this.enquireHandler = {
            match: ::this.attach,
            unmatch: ::this.detach
        }
    }
    prepare() {
        enquire.register(queries.largeUp, this.enquireHandler)
    }

    destroy() {
        enquire.unregister(queries.largeUp, this.enquireHandler)
    }

    attach() {
        this.ref.link.addEventListener('mouseenter', this.handleMouseEnter)
        this.ref.link.addEventListener('mouseleave', this.handleMouseLeave)
        this.ref.link.addEventListener('mousemove', this.handleMouseMove)
    }

    detach() {
        this.ref.link.removeEventListener('mouseenter', this.handleMouseEnter)
        this.ref.link.removeEventListener('mouseleave', this.handleMouseLeave)
        this.ref.link.removeEventListener('mousemove', this.handleMouseMove)
    }

    handleMouseEnter = event => {
        this.box = this.element.getBoundingClientRect()
        this.nameBox = this.ref.name.getBoundingClientRect()

        this.move = {
            active: true,
            startX: event.clientX,
            startY: event.clientY
        }

        this.element.classList.add(STATES.ACTIVE)
        this.emit('enter')
    }

    handleMouseLeave = event => {
        this.move.active = false
        this.element.classList.remove(STATES.ACTIVE)
        this.emit('leave')
    }

    handleMouseMove = event => {
        if (!this.move.active) {
            return
        }

        this.move.x = event.clientX
        this.move.y = event.clientY
        requestAnimationFrame(this.render)
    }

    render = () => {
        let x = this.nameBox.left - this.box.left
        let y = this.nameBox.top - this.box.top

        x += this.move.x - this.move.startX + (this.move.startX - this.nameBox.left)
        y += this.move.y - this.move.startY + (this.move.startY - this.nameBox.top)

        this.ref.image.style.left = `${x}px`
        this.ref.image.style.top = `${y}px`
    }
}